import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
// COMPONENTS
import { Calendar } from 'primereact/calendar';
// ASSETS
import { Wrapper } from './TeamCalendar.style';
import moment, { Moment } from 'moment';

const TeamCalendar = () => {
	const { t } = useTranslation();
	const [date, setDate] = useState(new Date());
	const getWindowDimensions = () => {
		const { innerWidth: width, innerHeight: height } = window;
		return {
			width,
			height,
		};
	};
	const [windowDimensions, setWindowDimensions] = useState<{ width: number; height: number }>(getWindowDimensions());
	useEffect(() => {
		function handleResize() {
			setWindowDimensions(getWindowDimensions());
		}

		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	const [smallScreenDate, setSmallScreenDate] = useState<Moment>(moment());

	return (
		<Wrapper className="rounded-3xl border">
			{windowDimensions.width > 1280 ? (
				<Calendar
					className="w-full"
					panelClassName="p-0 text-center font-manropeBold text-sm text-[#AFAFAF]"
					inputClassName="text-white rounded-lg bg-[#01ABC1]"
					todayButtonClassName="text-white rounded-lg bg-[#01ABC1] p-primary-button"
					headerTemplate={() => (
						<Link to="/calender" className="text-decoration-none absolute right-2">
							<div className="text__default m-0 font-manropeBold text-sm text-[#afafaf]">
								{t('view_all')} <i className="pi pi-arrow-right text__default ml-1 text-xs"></i>
							</div>
						</Link>
					)}
					dateTemplate={(date) => {
						return <div className="text__default date_area l p-0 text-center font-manropeBold text-sm text-[#AFAFAF]">{date.day}</div>;
					}}
					value={date}
					onChange={(e) => setDate(e?.value as Date)}
					inline
					view="date"
				/>
			) : (
				<div className="small__view__calender flex h-full flex-col justify-between">
					<div className="smallview__calendar__header flex justify-between">
						<div className="flex items-center gap-1">
							<span
								className="p-datepicker-prev-icon pi pi-chevron-left text-[#01ABC1]"
								onClick={() => {
									setSmallScreenDate(moment(smallScreenDate).subtract(1, 'months'));
								}}
							></span>
							<div className="current_month text-[12px] font-bold text-[#01ABC1]">{smallScreenDate.format('MMM, YYYY')}</div>
							<span
								className="p-datepicker-prev-icon pi pi-chevron-right text-[#01ABC1]"
								onClick={() => {
									setSmallScreenDate(moment(smallScreenDate).add(1, 'months'));
								}}
							></span>
						</div>
						<Link to="/calender" className="text-decoration-none">
							<div className="text__default m-0 text-[#afafaf]">
								{t('view_all')}
								<i className="pi pi-arrow-right ps-1 text-[10px]"></i>
							</div>
						</Link>
					</div>
					<div className="smallview__calendar__content flex items-center justify-between pt-3">
						<span
							className="p-datepicker-prev-icon pi pi-chevron-left text-[11px] text-[#afafaf]"
							onClick={() => {
								setSmallScreenDate(moment(smallScreenDate).subtract(1, 'days'));
							}}
						></span>
						<div className="current_month text-[50px] font-[900] text-[#01ABC1]">{smallScreenDate.format('DD')}</div>
						<span
							className="p-datepicker-prev-icon pi pi-chevron-right text-[11px] text-[#afafaf]"
							onClick={() => {
								setSmallScreenDate(moment(smallScreenDate).add(1, 'days'));
							}}
						></span>
					</div>
					<div className="current_month text-center text-[16px] font-[900] text-[#01ABC1]">{moment(smallScreenDate).format('dddd')}</div>
				</div>
			)}
		</Wrapper>
	);
};

export default TeamCalendar;
